import { createFeatureSelector } from '@ngrx/store';
import { AuthDataState } from './auth.reducer';

export const authDataState = createFeatureSelector<AuthDataState>('auth');
export { AuthDataState };
